
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoySpecialPurpose as ObiSimplifiedBuoySpecialPurposeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-special-purpose.js';
 
 
 

 
 export const ObiSimplifiedBuoySpecialPurpose = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-special-purpose',
   elementClass: ObiSimplifiedBuoySpecialPurposeElement,
   events: {
     
   }
  });
 
 